<template>
  <div id="modalSegundaVia">
    <q-dialog v-model="OpenDialogSegundaVia" persistent>
      <!-- Mesmo molde do modal-editar-settings (Configurações do WhatsApp): campos no
           estilo padrão, grade q-col-gutter-md e ações no rodapé. -->
      <q-card style="width: 600px; max-width: 95vw">
        <q-card-section class="row items-center no-wrap">
          <div class="text-h6">2ª via pelo agente de IA</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="fechar" />
        </q-card-section>
        <q-separator />

        <q-card-section v-if="carregando" class="text-center q-pa-lg">
          <q-spinner color="primary" size="2em" />
        </q-card-section>

        <q-card-section v-else-if="erro">
          <q-banner class="bg-red-1 text-red-9" rounded>{{ erro }}</q-banner>
        </q-card-section>

        <q-card-section v-else-if="!status.disponivel">
          <q-banner class="bg-grey-3" rounded>
            Disponível só com o provedor DouraSat. Escolha a DouraSat em Configurações do WhatsApp.
          </q-banner>
        </q-card-section>

        <template v-else>
          <q-card-section>
            <div class="q-pa-md">
              <div class="q-col-gutter-md row">
                <template v-if="!status.ativo">
                  <div class="col-12">
                    O agente de IA da DouraSat passa a enviar a 2ª via do boleto e a nota fiscal ao cliente que
                    pedir no WhatsApp. O cliente é identificado pelo número do WhatsApp, sem pedir CPF ou CNPJ.
                    As regras abaixo já podem ser ajustadas antes de ativar.
                  </div>
                  <div class="col-12">
                    <q-select
                      v-model="agenteId"
                      :options="opcoesAgentes"
                      :loading="carregandoAgentes"
                      emit-value
                      map-options
                      label="Agente que vai atender"
                    >
                      <template v-slot:append>
                        <q-icon name="help_outline">
                          <q-tooltip max-width="360px">
                            O agente da DouraSat que passa a enviar boleto e nota fiscal. A função de 2ª via é anexada só a ele; os outros agentes da conta não mudam. Depois de ativar, cole no prompt dele a instrução que aparece nesta tela.
                          </q-tooltip>
                        </q-icon>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-12" v-if="funcoesExistentes.length">
                    <q-select
                      v-model="funcaoId"
                      :options="opcoesFuncoes"
                      emit-value
                      map-options
                      clearable
                      label="Reaproveitar função já criada (opcional)"
                      hint="Use quando a 2ª via já funcionava por outro caminho nesta conta."
                    >
                      <template v-slot:append>
                        <q-icon name="help_outline">
                          <q-tooltip max-width="360px">
                            Aparece quando esta conta da DouraSat já tem uma função de 2ª via configurada. Escolhendo uma, ela é reaproveitada e passa a ser atendida pelo DouraSoft: o método de comunicação usado antes por essa função para de funcionar na hora. Sem escolher, uma função nova é criada.
                          </q-tooltip>
                        </q-icon>
                      </template>
                    </q-select>
                  </div>
                </template>

                <template v-else>
                  <div class="col-12">
                    <q-chip color="green" text-color="white" icon="check">Ativa</q-chip>
                    <span class="text-caption">Conta DouraSat {{ status.subconta_uid }} · agente {{ status.agente_id }}</span>
                    <div v-if="status.outras_empresas.length" class="text-caption q-mt-xs">
                      Esta conta DouraSat também atende: {{ status.outras_empresas.join(", ") }}
                    </div>
                  </div>
                  <div class="col-12">
                    <q-input
                      :model-value="trechoInstrucao"
                      type="textarea"
                      readonly
                      autogrow
                      label="Instrução para o agente"
                      hint="Cole este trecho nas instruções do agente, no painel da DouraSat."
                    >
                      <template v-slot:append>
                        <q-btn flat round dense icon="content_copy" color="primary" @click="copiar">
                          <q-tooltip>Copiar</q-tooltip>
                        </q-btn>
                      </template>
                    </q-input>
                  </div>
                </template>

                <!-- F2: as regras ficam disponíveis mesmo com a 2ª via inativa, para a empresa
                     configurar antes de ativar (PUT /segunda-via/config não exige ativação). -->
                <div class="col-12 text-subtitle2">Regras</div>
                <div class="col-12">
                  <q-select
                    v-model="opcoes.segundavia_varios_cadastros"
                    :options="opcoesVariosComPadrao"
                    emit-value
                    map-options
                    label="Mesmo telefone em mais de um cadastro"
                    :error="!!erros.segundavia_varios_cadastros"
                    :error-message="erros.segundavia_varios_cadastros"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip max-width="360px">
                          Quando o número do WhatsApp aparece em mais de um cadastro (sócios, contador de várias empresas, número compartilhado), não dá para saber de quem é o documento. "Não enviar": o agente não envia nada e passa a conversa para um atendente. "Usar todos": procura os documentos em todos os cadastros com esse número.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
                <!-- O modo de teste do painel da DouraSat fica sempre aceito (padrão do back);
                     não há opção na tela para desligar. -->
                <div class="col-12 row items-center no-wrap">
                  <q-toggle v-model="opcoes.segundavia_conferir_contato" label="Conferir o contato na DouraSat (recomendado)" />
                  <q-icon name="help_outline" size="xs" class="q-ml-xs text-grey-7 cursor-pointer">
                    <q-tooltip max-width="360px">
                      Antes de enviar, confere na DouraSat que o contato da conversa tem mesmo esse número e está no
                      mesmo canal. Se não bater, nada é enviado. É uma proteção a mais contra uso indevido.
                      {{ hintToggle("segundavia_conferir_contato") }}
                    </q-tooltip>
                  </q-icon>
                </div>
                <div class="col-12">
                  <q-input
                    v-model="opcoes.segundavia_dias_limite_vencido"
                    type="number"
                    label="Não enviar boleto vencido há mais de (dias)"
                    :hint="hintDias"
                    :error="!!erros.segundavia_dias_limite_vencido"
                    :error-message="erros.segundavia_dias_limite_vencido"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip max-width="360px">
                          Boleto vencido há mais dias do que isso não é reenviado como está: o agente pergunta se o cliente quer atualizar o boleto. Deixe vazio para reenviar sempre, mesmo vencido.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-md-6">
                  <q-select
                    v-model="opcoes.segundavia_mes_mensagem"
                    :options="opcoesMesComPadrao"
                    emit-value
                    map-options
                    label="Mês citado na mensagem ao cliente"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip max-width="360px">
                          Qual mês o agente cita na resposta. A cobrança costuma ter a referência de um mês e vencer no anterior (ex.: referência 10/2026, vencimento 20/09). "Referência do boleto" cita 10/2026; "Mês que o cliente pediu" repete o mês que o cliente falou.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-md-6">
                  <q-select
                    v-model="opcoes.segundavia_nf_criterio"
                    :options="opcoesNfComPadrao"
                    emit-value
                    map-options
                    label="Nota fiscal do mês pedido é a que"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip max-width="360px">
                          Quando o cliente pede a nota fiscal de um mês, qual nota é entregue: a da cobrança com a referência daquele mês, ou a da cobrança que vence naquele mês.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 row items-center no-wrap">
                  <q-toggle v-model="opcoes.segundavia_aviso_email_ativo" label="Avisar o financeiro por e-mail" />
                  <q-icon name="help_outline" size="xs" class="q-ml-xs text-grey-7 cursor-pointer">
                    <q-tooltip max-width="360px">
                      Manda um e-mail para o endereço abaixo quando o agente não resolve sozinho: número não
                      identificado, boleto vencido além do prazo, outro boleto antigo em aberto ou serviço indisponível.
                      O e-mail traz o telefone e o que foi pedido, nunca o link do documento.
                      {{ hintToggle("segundavia_aviso_email_ativo") }}
                    </q-tooltip>
                  </q-icon>
                </div>
                <div class="col-12">
                  <q-input
                    v-model="opcoes.segundavia_aviso_email"
                    type="email"
                    label="E-mail do financeiro"
                    hint="Recebe os avisos do agente. O cliente não vê este endereço."
                    :error="!!erros.segundavia_aviso_email"
                    :error-message="erros.segundavia_aviso_email"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip max-width="360px">
                          Endereço que recebe os avisos acima. As mensagens do agente ao cliente não citam este e-mail nem o setor financeiro.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
            </div>
          </q-card-section>

          <q-card-actions align="right" class="text-primary">
            <template v-if="!status.ativo">
              <q-btn
                flat
                label="Ativar"
                :loading="salvando"
                :disable="!agenteId"
                @click="ativar"
                class="bg-primary text-white"
                style="margin-right: 22px; margin-bottom: 10px"
              />
            </template>
            <template v-else>
              <q-btn
                flat
                label="Desativar"
                :loading="salvando"
                @click="confirmarDesativar"
                class="bg-negative text-white"
                style="margin-right: 22px; margin-bottom: 10px"
              />
              <q-btn
                flat
                label="Gerar nova chave"
                :loading="salvando"
                @click="confirmarNovaChave"
                class="bg-primary text-white"
                style="margin-right: 22px; margin-bottom: 10px"
              />
            </template>
            <q-btn
              flat
              label="Salvar"
              :loading="salvando"
              @click="salvarRegras"
              class="bg-positive text-white"
              style="margin-right: 22px; margin-bottom: 10px"
            />
          </q-card-actions>
        </template>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { mapGetters } from "vuex";
import { Dialog, Notify } from "quasar";

// Spec n8n §10, sem nome de empresa: serve a qualquer cliente do Assinaturas.
const TRECHO_INSTRUCAO =
  "**2ª via de boleto ou nota fiscal:** quando o cliente pedir 2ª via, boleto, fatura, código de barras, " +
  "Pix para pagar, nota fiscal ou NF, chame a função `segunda_via_documento` na hora, sem pedir CNPJ, CPF " +
  "ou telefone — o cliente é identificado pelo número do WhatsApp. Preencha `tipo` com `boleto` ou `nf` e " +
  "`competencia` com o mês citado (MM/AAAA), ou deixe vazio se ele não citou mês. Responda com o texto do " +
  "campo `mensagem` exatamente como veio. Se o cliente pedir boleto e nota juntos, chame a função duas " +
  "vezes. Nunca invente valores, datas ou links. Se a resposta trouxer `encaminhar_atendente: true`, " +
  "transfira a conversa para o atendimento humano.";

const ERRO_CARREGAR = "Não foi possível carregar a 2ª via, tente novamente.";
const ERRO_GENERICO = "Houve um erro, tente novamente!";

export default {
  name: "modal-segunda-via",
  data() {
    return {
      carregando: false,
      carregandoAgentes: false,
      salvando: false,
      erro: "",
      status: { disponivel: false, ativo: false, outras_empresas: [], padroes: {} },
      agentes: [],
      funcoesExistentes: [],
      agenteId: null,
      funcaoId: null,
      opcoes: {},
      // O que está gravado no servidor: base para saber se há regra editada e não salva.
      opcoesSalvas: {},
      erros: {},
      trechoInstrucao: TRECHO_INSTRUCAO,
      opcoesVarios: [
        { label: "Não enviar", value: "negar" },
        { label: "Usar todos os cadastros com o número", value: "usar_todos" },
      ],
      opcoesMes: [
        { label: "Referência do boleto", value: "referencia" },
        { label: "Mês que o cliente pediu", value: "pedido" },
      ],
      opcoesNf: [
        { label: "Tem a referência do mês pedido", value: "referencia" },
        { label: "Vence no mês pedido", value: "vencimento" },
      ],
    };
  },
  computed: {
    regrasAlteradas() {
      const campos = new Set(Object.keys(this.opcoes).concat(Object.keys(this.opcoesSalvas)));

      return [...campos].some(campo => String(this.opcoes[campo]) !== String(this.opcoesSalvas[campo]));
    },
    ...mapGetters(["OpenDialogSegundaVia"]),
    opcoesAgentes() {
      return this.agentes.map(agente => ({ label: agente.nome || agente.id, value: agente.id }));
    },
    opcoesFuncoes() {
      return this.funcoesExistentes.map(funcao => ({ label: `${funcao.nome} (${funcao.id})`, value: funcao.id }));
    },
    // F1 (spec §8): marca "(padrão)" na opção que vem em status.padroes (mesmas chaves de opcoes).
    opcoesVariosComPadrao() {
      return this.comPadrao(this.opcoesVarios, "segundavia_varios_cadastros");
    },
    opcoesMesComPadrao() {
      return this.comPadrao(this.opcoesMes, "segundavia_mes_mensagem");
    },
    opcoesNfComPadrao() {
      return this.comPadrao(this.opcoesNf, "segundavia_nf_criterio");
    },
    hintDias() {
      const base = "Vazio desliga a regra: o boleto vencido é enviado sempre.";
      const padroes = this.status.padroes || {};
      if (!("segundavia_dias_limite_vencido" in padroes)) {
        return base;
      }
      const padrao = padroes.segundavia_dias_limite_vencido;

      return `${padrao === "" ? "Padrão: desligado" : `Padrão: ${padrao} dias`}. ${base}`;
    },
  },
  methods: {
    // F1: opções do select com "(padrão)" na que casa com status.padroes[campo].
    comPadrao(opcoes, campo) {
      const padrao = (this.status.padroes || {})[campo];

      return opcoes.map(opcao =>
        opcao.value === padrao ? Object.assign({}, opcao, { label: `${opcao.label} (padrão)` }) : opcao
      );
    },
    hintToggle(campo) {
      const padroes = this.status.padroes || {};
      if (!(campo in padroes)) {
        return "";
      }

      return `Padrão: ${padroes[campo] ? "ligado" : "desligado"}.`;
    },
    fechar() {
      this.$store.commit("OpenDialogSegundaVia", false);
    },
    avisar(mensagem, sucesso) {
      Notify.create({ message: mensagem, color: sucesso ? "green" : "red", position: "top-right" });
    },
    carregar() {
      this.carregando = true;
      this.erro = "";

      return axios
        .get("/segunda-via/status")
        .then(res => {
          this.carregando = false;

          // O interceptor resolve erro de HTTP como { error } — não há res.data.
          if (res.error || !res.data || !res.data.success) {
            this.erro = (res.data && res.data.message) || ERRO_CARREGAR;
            return;
          }

          this.status = Object.assign({}, res.data, { outras_empresas: res.data.outras_empresas || [] });
          this.opcoes = Object.assign({}, res.data.opcoes);
          this.opcoesSalvas = Object.assign({}, res.data.opcoes);
          this.erros = {};

          if (res.data.disponivel && !res.data.ativo) {
            return this.carregarAgentes();
          }
        })
        .catch(() => {
          this.carregando = false;
          this.erro = ERRO_CARREGAR;
        });
    },
    carregarAgentes() {
      this.carregandoAgentes = true;

      return axios
        .get("/segunda-via/agentes")
        .then(res => {
          this.carregandoAgentes = false;

          if (res.error || !res.data || !res.data.success) {
            this.avisar((res.data && res.data.message) || "Não foi possível listar os agentes da DouraSat.", false);
            return;
          }

          this.agentes = res.data.agentes || [];
          this.funcoesExistentes = res.data.funcoes_existentes || [];
        })
        .catch(() => {
          this.carregandoAgentes = false;
          this.avisar("Não foi possível listar os agentes da DouraSat.", false);
        });
    },
    ativar() {
      return this.salvarPendentes().then(salvou => {
        if (!salvou) {
          return;
        }

        return this.enviar(
          axios.post("/segunda-via/ativar", { agente_id: this.agenteId, funcao_id: this.funcaoId || null })
        );
      });
    },
    // Ativar/Gerar nova chave/Desativar recarregam a tela no fim: regra editada e não salva
    // sumiria sem aviso. Salva antes, e só segue se o salvar passou na validação.
    salvarPendentes() {
      return this.regrasAlteradas ? this.salvarRegras() : Promise.resolve(true);
    },
    salvarRegras() {
      this.salvando = true;
      this.erros = {};

      return axios
        .put("/segunda-via/config", { opcoes: this.opcoes })
        .then(res => {
          this.salvando = false;

          if (res.error || !res.data) {
            this.avisar("Houve um erro ao salvar as regras, tente novamente!", false);
            return false;
          }

          this.erros = res.data.erros || {};
          this.avisar(res.data.message, res.data.success);

          if (res.data.success) {
            this.opcoes = Object.assign({}, res.data.opcoes);
            this.opcoesSalvas = Object.assign({}, res.data.opcoes);
          }

          return !!res.data.success;
        })
        .catch(() => {
          this.salvando = false;
          this.avisar("Houve um erro ao salvar as regras, tente novamente!", false);
          return false;
        });
    },
    confirmarNovaChave() {
      return new Promise(resolve => {
        Dialog.create({
          title: "Gerar nova chave",
          message: "A chave atual deixa de valer na hora e a função do agente passa a usar a nova. Continuar?",
          cancel: true,
          persistent: true,
        })
          .onOk(() => resolve(this.depoisDeSalvar(() => axios.post("/segunda-via/gerar-chave"))))
          .onCancel(() => resolve());
      });
    },
    confirmarDesativar() {
      return new Promise(resolve => {
        Dialog.create({
          title: "Desativar a 2ª via",
          message: "O agente deixa de enviar a 2ª via para os clientes desta empresa. Continuar?",
          cancel: true,
          persistent: true,
        })
          .onOk(() => resolve(this.depoisDeSalvar(() => axios.post("/segunda-via/desativar"))))
          .onCancel(() => resolve());
      });
    },
    depoisDeSalvar(requisitar) {
      return this.salvarPendentes().then(salvou => (salvou ? this.enviar(requisitar()) : undefined));
    },
    enviar(requisicao) {
      this.salvando = true;

      return requisicao
        .then(res => {
          this.salvando = false;

          if (res.error || !res.data) {
            this.avisar(ERRO_GENERICO, false);
            return;
          }

          this.avisar(res.data.message, res.data.success);

          if (res.data.success) {
            return this.carregar();
          }
        })
        .catch(() => {
          this.salvando = false;
          this.avisar(ERRO_GENERICO, false);
        });
    },
    copiar() {
      const falhou = () => this.avisar("Não consegui copiar; selecione o texto e copie.", false);

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        falhou();
        return Promise.resolve();
      }

      return navigator.clipboard
        .writeText(this.trechoInstrucao)
        .then(() => this.avisar("Trecho copiado.", true))
        .catch(falhou);
    },
  },
  watch: {
    OpenDialogSegundaVia(aberto) {
      if (aberto) {
        this.carregar();
      }
    },
  },
};
</script>
